import ChoiceInput from "./inputs/ChoiceInput";
import RadioInput from "./inputs/RadioInput";
import TextInput from "./inputs/TextInput";
import CurrencyInput from "./inputs/CurrencyInput";
import { Check, X, ChevronRight } from 'lucide-react';

const QuestionBlock = ({
    question,
    value,
    error,
    isActive,
    isAnswered,
    isLocked,
    onChange,
    onNext,
    onSubmit,
    isFirstQuestion
}) => {
    const isConsent = question.question_type === "consent";
    const isFirstNoSubmit =
        isFirstQuestion && value === "No";


    const handleChange = (val) => {
        onChange(question.question_uid, val);
    };

    const renderInput = () => {
        // CONSENT (frontend-only)
        if (isConsent) {
            return (
                <label className="flex items-start gap-3 cursor-pointer">
                    <input
                        type="checkbox"
                        checked={!!value}
                        onChange={(e) => handleChange(e.target.checked)}
                        className="mt-1 w-4 h-4 accent-[#FB6514]"
                    />
                    <span className="text-[14px] text-[#494E58]">
                        I confirm this information is accurate to the best of my knowledge.
                    </span>
                </label>
            );
        }

        if (question.question_type === "choice") {
            // FIRST QUESTION → BUTTONS
            if (isFirstQuestion) {
                return (
                    <ChoiceInput
                        options={question.options}
                        value={value}
                        disabled={isLocked}
                        onChange={handleChange}
                    />
                );
            }

            // ALL OTHER CHOICE QUESTIONS → RADIO
            return (
                <RadioInput
                    options={question.options}
                    value={value}
                    disabled={isLocked}
                    onChange={handleChange}
                />
            );
        }

        if (question.question_type === "text") {
            return (
                <TextInput
                    value={value}
                    disabled={isLocked}
                    onChange={handleChange}
                />
            );
        }

        if (question.question_type === "currency") {
            return (
                <CurrencyInput
                    value={value}
                    disabled={isLocked}
                    onChange={handleChange}
                />
            );
        }

        return null;
    };

    return (
        <>
            {/* QUESTION CARD */}
            <div
                id={question.question_uid}
                className={`relative mb-3 p-4 rounded-lg bg-white border
          ${error ? "border-red-400" : "border-gray-200"}
        `}
            >
                {/* LOCK OVERLAY ONLY FOR FUTURE QUESTIONS */}
                {isLocked && (
                    <div className="absolute inset-0 bg-white/70 z-10 rounded-lg cursor-not-allowed" />
                )}

                {/* QUESTION TITLE */}
                <label className="block font-medium mb- text-[#494E58] mb-3">
                    {question.question_text}
                    {!isConsent && (
                        question.is_required
                            ? <span className="text-red-500 ml-1">*</span>
                            : <span className="text-gray-400"> (optional)</span>
                    )}
                </label>

                {/* INPUT */}
                {renderInput()}

                {/* ERROR MESSAGE */}
                {error && (
                    <p className="mt-2 text-sm text-red-500">
                        {error}
                    </p>
                )}
            </div>

            {/* ACTION BUTTON */}
            {isActive && (
                <div className="mt-2 mb-6 text-left text-[14px]">
                    {isConsent ? (
                        <button
                            onClick={onSubmit}
                            disabled={!value}
                            style={{ backgroundColor: "#FB512D" }}
                            className="px-6 py-2 text-white rounded-[4px] disabled:opacity-40"
                        >
                            Submit
                        </button>
                    ) : (
                        <button
                            onClick={isFirstNoSubmit ? onSubmit : onNext}
                            disabled={!value && question.is_required}
                            style={{ backgroundColor: "#FB512D" }}
                            className="flex gap-2 px-6 py-2 text-white rounded-[4px] disabled:opacity-40"
                        >
                            {isFirstNoSubmit ? "Submit" : (
                                <>
                                    Next <ChevronRight className="w-[14px]" />
                                </>
                            )}
                        </button>

                    )}
                </div>
            )}
        </>
    );
};

export default QuestionBlock;

